import { Controller } from "@hotwired/stimulus"

// Reloads the page while something it shows is on its way (05.10.2026: a
// backup asked for or running) -- the progress bar appears and moves without a
// click, and the button comes back once it is done.
export default class extends Controller {
  static values = { interval: { type: Number, default: 5000 } }

  connect() {
    this.timer = setTimeout(() => window.Turbo.visit(window.location.href, { action: "replace" }), this.intervalValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
